import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCountStyles.countText = {
    css: css`
        white-space: nowrap;
        font-size: 16px;
        color: ${getColor("text.main")};
    `,
    weight: 700,
};
productCountStyles.itemsText = {
    css: css`
        white-space: nowrap;
        font-size: 16px;
        color: ${getColor("text.main")};
    `,
};

productCountStyles.wrapper = {
    css: css`
        margin-top: 0px !important;
        margin-bottom: 15px;
    `,
};
